import RegisterView from './Register.view';
export * from './Register.view';

export const Register = (props) => RegisterView(props);

export default Register;

